export default [
  { value: 'PRIVATE', label: 'Ja' },
  { value: 'STATUTORY', label: 'Nein' }
]
